<template>
  <div class="user-avatar">
    <component
      :is="hasTooltip ? 'm-tooltip' : 'div'"
      placement="top"
    >
      <m-avatar
        :size="size"
        :src="profileImage"
        :class="['user-avatar']"
        :bordered="bordered"
        :text="avatarText"
        black-and-white
        shape="circle"
      />
      <template
        v-if="hasTooltip"
        #title
      >
        {{ avatarText }}
      </template>
    </component>
  </div>
</template>

<script>
import useUser from 'shared/composables/user';
import { computed, toRef } from 'vue';
import { isNullOrUndefined } from 'shared/lib/object/object';
import { useI18n } from 'vue-i18n';

export default {
  name: 'UserAvatar',
  props: {
    user: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      required: true,
    },
    size: {
      type: Number,
      default: 24,
    },
    hasTooltip: {
      type: Boolean,
      default: false,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const i18n = useI18n();
    const avatarText = computed(() => {
      if (props.user === null) {
        return i18n.t('user.deleted.name');
      }

      return useUser(toRef(props, 'user')).displayName.value;
    });

    return { avatarText };
  },
  computed: {
    profileImage() {
      if (this.user === null) {
        return '';
      }

      if (!isNullOrUndefined(this.user.archivedAt)) {
        return new URL('@/assets/img/profile-image-archived.png', import.meta.url).href;
      }

      if (!isNullOrUndefined(this.user.profileImage)) {
        return this.user.profileImage.getURL;
      }
      return '';
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
  .user-avatar {
    display: inline;
  }
</style>
